
import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaHeart } from 'react-icons/fa';
import { WishlistContext } from '../Wishlist/WishlistContext';

const SearchPage = () => {
  const { addToWishlist } = useContext(WishlistContext);
  const [query, setQuery] = useState('');
  const [products, setProducts] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');

  useEffect(() => {
    fetch('https://api.glocart.in/pages/api/products/get')
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setProducts(data);
        } else if (Array.isArray(data?.products)) {
          setProducts(data.products);
        } else {
          console.error("Unexpected API response:", data);
          setProducts([]);
        }
      })
      .catch(error => {
        console.error("Error fetching products:", error);
        setProducts([]);
      });
  }, []);

  useEffect(() => {
    const results = products.filter(product => {
      const matchesQuery = product.name.toLowerCase().includes(query.toLowerCase());
      const matchesCategory = selectedCategory ? product.category === selectedCategory : true;
      return matchesQuery && matchesCategory;
    });
    setFiltered(results);
  }, [query, products, selectedCategory]);

  const categories = [...new Set(products.map(p => p.category).filter(Boolean))];

  return (
    <div className="container py-5">
      <h2 className="fw-bold mb-4">SEARCH PRODUCTS</h2>

      <input type="text" className="form-control mb-4 px-4 py-2 border rounded-pill shadow-sm" placeholder="Search for delicious items..." value={query} onChange={e => setQuery(e.target.value)} />

      <div className="mb-4 d-flex flex-wrap gap-2">
        <button className={`btn rounded-pill px-3 py-1 ${selectedCategory === '' ? 'btn-dark' : 'btn-outline-dark'}`} onClick={() => setSelectedCategory('')}>All</button>
        {categories.map(category => (
          <button key={category} className={`btn rounded-pill px-3 py-1 ${selectedCategory === category ? 'btn-dark' : 'btn-outline-dark'}`} onClick={() => setSelectedCategory(category)}>
            {category}
          </button>
        ))}
      </div>

      <div className="row gy-4">
        {filtered.map(product => (
          <div className="col-6 col-md-4 col-lg-3" key={product.id}>
            <div className="d-flex flex-column h-100 position-relative bg-white rounded shadow-sm p-3">
              <Link to={`/product/${product.id}`}>
                <div style={{ height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src={product.image} alt={product.name} style={{ maxHeight: '100%', objectFit: 'contain' }} />
                </div>
              </Link>

              <div className="position-absolute top-0 end-0 p-2 text-danger" style={{ fontSize: '1.2rem', cursor: 'pointer' }}
                onClick={() => {
                  const productToAdd = {
                    id: product.id,
                    name: product.name,
                    image: product.image,
                    price: product.price,
                  };
                  addToWishlist(productToAdd);
                  alert(`${product.name} has been added to your wishlist!`);
                }}>
                <FaHeart />
              </div>

              <div className="mt-3">
                <h6 className="fw-bold">{product.name}</h6>
                <div className="mb-2">
                  {(() => {
                    const isValid = product.validity && new Date(product.validity) > new Date();
                    if (product.discount && isValid) {
                      const discountedPrice = Math.round(product.price - (product.price * product.discount) / 100);
                      return (
                        <>
                          <span className="text-muted text-decoration-line-through me-2">₹{product.price}</span>
                          <span className="fw-bold text-danger me-2">₹{discountedPrice}</span>
                          <span className="badge bg-success">{product.discount}% OFF</span>
                        </>
                      );
                    } else {
                      return <span className="fw-bold text-muted">₹{product.price}</span>;
                    }
                  })()}
                </div>
                <Link to={`/product/${product.id}`} className="btn btn-sm w-100" style={{ backgroundColor: '#870a10', color: '#fff' }}>View</Link>
              </div>
            </div>
          </div>
        ))}
      </div>

      {filtered.length === 0 && (
        <div className="text-center text-muted py-4">No products match your search.</div>
      )}
    </div>
  );
};

export default SearchPage;
